import { render, staticRenderFns } from "./UsuarioPermissoes.vue?vue&type=template&id=18dfb4b3&scoped=true"
import script from "./UsuarioPermissoes.vue?vue&type=script&lang=js"
export * from "./UsuarioPermissoes.vue?vue&type=script&lang=js"
import style0 from "./UsuarioPermissoes.vue?vue&type=style&index=0&id=18dfb4b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfb4b3",
  null
  
)

export default component.exports